// redux/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user', // The name of the slice
  initialState: {user:null  , device_id:null , unreadCount:0 }, // The initial state of the slice
  reducers: {
    
    setUser: (state, action) => {
      let user={...action.payload};
      user.displayName=`${user?.name ? user?.name : 'Admin User'}`;
      state.user=user;
    }, // Action to set the user in the state
    logout: (state) => {
      localStorage.clear();
     state.user=null
    }, // Action to clear the user from the state
    setToken: (state, action) => {
      state.device_id = action.payload;
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
  },
});

// Exporting actions
export const { setUser, logout ,setToken , setUnreadCount } = userSlice.actions;
export const selectUser = (state) => state.user.user;
// Exporting the reducer
export default userSlice.reducer;
